import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import {
  FullPatient,
  PatientAddress,
  PatientSubscription,
} from 'src/app/_models/patient.model';
import { Pharmacy } from 'src/app/_models/PSP/pharmacy.model';
import { PatientService } from 'src/app/_services/patient.service';
import { AddNewAddressComponent } from '../add-new-address/add-new-address.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PspSubscriptionStatusEnum } from '../../../enums/psp-subscription-status-enum';
import { MedicationRequestBoxService } from 'src/app/_services/PSP/medication-request-box.service';
import { MedicationRequestService } from 'src/app/_services/PSP/medication-request.service';

@Component({
  selector: 'app-request-home-delivery',
  templateUrl: './request-home-delivery.component.html',
  styleUrls: ['./request-home-delivery.component.scss'],
})
export class RequestHomeDeliveryComponent implements OnInit {
  requestData: any = {};
  stepCount = 1;
  pharmacyList: Pharmacy[] = [];
  selectedAddress = {} as PatientAddress;
  subscriptionId: number;
  addresses: PatientAddress[];
  patient: FullPatient;
  selectedSubscription: PatientSubscription;
  RequestNotes: string;
  requestFOC;
  requestEmptyBoxes;
  requestSalesPurchase;
  newAddress = {} as PatientAddress;
  patientId: number;
  discountToggle: boolean = false;
  discountedItemsQuantity: number = 1;
  programPublicPrice: number;
  discountPercentage: string = '';
  totalPriceAfterDiscount: number = 0;
  pspSubscriptionStatus: typeof PspSubscriptionStatusEnum =
    PspSubscriptionStatusEnum;
  isRocheProgram = false;
  hasPatientDispensedBoxes: boolean = false;
  protected readonly PspSubscriptionStatusEnum = PspSubscriptionStatusEnum;
  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly toaster: ToastrService,
    private readonly patientService: PatientService,
    private readonly modalService: NgbModal,
    private readonly medicationRequestBoxService: MedicationRequestBoxService,
    private readonly medicationService: MedicationRequestService
  ) { }

  ngOnInit(): void {
    if (!this.patientService.patient) {
      this.goBack();
      return;
    }
    this.addresses = this.patientService.patientAddresses;
    this.patient = this.patientService.patient;
    this.selectedSubscription = this.patientService.selectedSubscription;
    this.programPublicPrice = this.selectedSubscription?.program?.productPrice;
    this.isRocheProgram = this.medicationService.isRocheRequest(
      this.selectedSubscription?.program?.companyName
    );

    this.requestEmptyBoxes = this.isRocheProgram ? 0 : null;
    this.activatedRoute.params.subscribe((params) => {
      this.subscriptionId = params.subscriptionId;
      this.patientId = +params.patientId;
    });
    this.hasPatientDispensedBoxesForProgram();
  }

  onChange(event): void {
    this.selectedAddress = event;
  }

  changeStep(step): void {
    this.stepCount = step === 4 ? 3 : step;
  }
  openNotificationModal(): void {
    this.onAddNewAddress();
  }

  onSubmit() {
    if (!this.discountToggle) {
      const body = {
        subscriptionId: this.subscriptionId,
        patientAddressId: this.selectedAddress.patientAddressId,
        notes: this.RequestNotes,
        freeOfChargeCount: this.requestFOC > 0 ? this.requestFOC : null,
        emptyBoxesCount:
          this.requestEmptyBoxes > 0 ? this.requestEmptyBoxes : null,
        purchasesCount:
          this.requestSalesPurchase > 0 ? this.requestSalesPurchase : null,
      };
      this.patientService.addMedicationRequest(body).subscribe((res) => {
        showNotification('success', 'Added Successfully', this.toaster);
        this.router.navigateByUrl('/patient-details/' + this.patientId);
      });
    } else {
      const body = {
        subscriptionId: this.subscriptionId,
        patientAddressId: this.selectedAddress.patientAddressId,
        notes: this.RequestNotes,
        quantity:
          this.discountedItemsQuantity > 0
            ? this.discountedItemsQuantity
            : null,
        publicPrice:
          this.programPublicPrice > 0 ? this.programPublicPrice : null,
        percentageOfTheDiscount:
          parseFloat(this.discountPercentage) > 0
            ? parseFloat(this.discountPercentage)
            : null,
        totalPriceAfterDiscount:
          this.totalPriceAfterDiscount > 0
            ? this.totalPriceAfterDiscount
            : null,
        emptyBoxesCount:
          this.requestEmptyBoxes > 0 ? this.requestEmptyBoxes : null,
      };
      this.patientService.addMedicationRequest(body).subscribe((res) => {
        showNotification('success', 'Added Successfully', this.toaster);
        this.router.navigateByUrl('/patient-details/' + this.patientId);
      });
    }
  }

  onAddNewAddress(): void {
    const modalRef = this.modalService.open(AddNewAddressComponent, {
      size: 'lg',
      backdrop: 'static',
      animation: true,
      centered: true,
    });
    modalRef.componentInstance.patientId = this.patientId;
    modalRef.result.then((result) => {
      if (!result) {
        return;
      }

      this.addresses.push(result);
    });
  }

  goBack(): void {
    window.history.back();
  }

  changeToggle() {
    this.discountToggle = !this.discountToggle;
    if (this.discountToggle) {
      this.requestEmptyBoxes = this.isRocheProgram
        ? this.requestEmptyBoxes
        : null;
      this.requestFOC = null;
      this.requestSalesPurchase = null;
      this.discountedItemsQuantity = 1;
      this.programPublicPrice =
        this.selectedSubscription?.program?.productPrice;
    }
    if (!this.discountToggle) {
      this.requestEmptyBoxes = this.isRocheProgram
        ? this.requestEmptyBoxes
        : null;
      this.discountedItemsQuantity = null;
      this.programPublicPrice = null;
      this.discountPercentage = null;
      this.totalPriceAfterDiscount = null;
    }
  }

  onBundleInput(event: any) {
    const input = event.target as HTMLInputElement;
    const inputValue = input?.value;

    const sanitizedValue = inputValue.replace(/[^0-9]/g, '');

    input.value = sanitizedValue;
  }

  onDiscountQtyInput(event: any) {
    const input = event.target as HTMLInputElement;
    const inputValue = input?.value;

    // Remove non-numeric characters
    const sanitizedValue = inputValue.replace(/[^0-9]/g, '');
    
    if (sanitizedValue !== '') {
      let numericValue = parseInt(sanitizedValue);

      if (this.isRocheProgram) {
        // For Roche program: min = 1, max = 6
        if (numericValue < 1) {
          numericValue = 1;
        } else if (numericValue > 6) {
          numericValue = 6;
        }
      } else {
        // For non-Roche programs: min = 1
        if (numericValue < 1) {
          numericValue = 1;
        }
      }

      input.value = numericValue.toString();
      this.discountedItemsQuantity = numericValue;
    } else {
      input.value = '';
      this.discountedItemsQuantity = null;
    }
  }

  onDiscountPercentageChange(event: any) {
    const input = event.target as HTMLInputElement;
    const inputValue = input?.value;

    if (inputValue !== '') {
      let sanitizedValue = inputValue.replace(/[^0-9.]/g, '');

      if (sanitizedValue.startsWith('.')) {
        sanitizedValue = '0' + sanitizedValue;
      }
      sanitizedValue = sanitizedValue.replace(/(\..*)\./g, '$1');

      const parsedValue = parseFloat(sanitizedValue);

      if (parsedValue >= 1 && parsedValue <= 99) {
        input.value = sanitizedValue;
        this.discountPercentage = sanitizedValue.toString();

        this.calculateTotalPriceAfterDiscount();
      } else if (parsedValue < 1) {
        input.value = '1';
      } else if (parsedValue > 99) {
        input.value = '99';
      } else {
        input.value = '';
      }
    }
  }

  calculateTotalPriceAfterDiscount() {
    const quantity = this.discountedItemsQuantity || 0;
    
    const rowTotal =
      quantity *
      this.programPublicPrice *
      (1 - parseFloat(this.discountPercentage) / 100);
    this.totalPriceAfterDiscount = parseFloat(rowTotal.toFixed(2));
  }

  hasPatientDispensedBoxesForProgram() {
    this.medicationRequestBoxService
      .hasPatientDispensedBoxes(this.selectedSubscription.id)
      .subscribe((res) => {
        this.hasPatientDispensedBoxes = res.data;
      });
  }

  emptyBoxesDisabled(): boolean {
    if (this.isRocheProgram) {
      return !this.hasPatientDispensedBoxes;
    } else {
      return this.discountToggle;
    }
  }

  isValidRequestEmptyBoxes(): boolean {
    if (this.isRocheProgram) {
      if (this.discountToggle) {
        return this.requestEmptyBoxes >= 0 && this.requestEmptyBoxes <= 6;
      } else {
        return this.requestEmptyBoxes > 0 && this.requestEmptyBoxes <= 6;
      }
    }

    return !!this.requestEmptyBoxes;
  }

  isValidDiscountedItemsQuantity(): boolean {
    if (this.isRocheProgram) {
      return (
        this.discountedItemsQuantity >= 1 && this.discountedItemsQuantity <= 6
      );
    }

    return !!this.discountedItemsQuantity;
  }

  isRequestFormDisabled(): boolean {
    const missingAddress = this.selectedAddress.id === 0;

    const discountFieldsIncomplete =
      this.discountToggle &&
      (
        !this.isValidDiscountedItemsQuantity() ||
        !this.discountPercentage ||
        !this.programPublicPrice
      );

    const noRequestOptionsSelected =
      !this.discountToggle &&
      !this.requestFOC &&
      !this.requestSalesPurchase &&
      !this.isValidRequestEmptyBoxes();

      const invalidEmptyBoxes = 
      this.hasEmptyBoxesValue() && 
      !this.isValidRequestEmptyBoxes();

      const invalidFoc = 
      this.hasFocValue() && 
      !this.isValidFocBoxes();

      const noRocheDataSelected =
      this.isRocheProgram &&
      !this.discountToggle &&
      !this.requestFOC;

    return (
      missingAddress ||
      discountFieldsIncomplete ||
      noRequestOptionsSelected ||
      invalidEmptyBoxes ||
      invalidFoc ||
      noRocheDataSelected
    );
  }

  hasEmptyBoxesValue(): boolean {
    return this.isRocheProgram 
        ? this.requestEmptyBoxes > 0 
        : this.requestEmptyBoxes != null;
  }

  hasFocValue(): boolean {
    return this.isRocheProgram 
        ? this.requestFOC > 0 
        : this.requestFOC != null;
  }

  isValidFocBoxes(): boolean {
    if (this.isRocheProgram) {
      return this.requestFOC > 0 && this.requestFOC <= 6;
    }

    return !!this.requestFOC;
  }

  onFocInput(event: any) {
    const input = event.target as HTMLInputElement;
    const inputValue = input?.value;

    // Remove non-numeric characters
    const sanitizedValue = inputValue.replace(/[^0-9]/g, '');
    
    if (sanitizedValue !== '') {
      let numericValue = parseInt(sanitizedValue);

      if (this.isRocheProgram) {
        // For Roche program: min = 1, max = 6
        if (numericValue < 1) {
          numericValue = 1;
        } else if (numericValue > 6) {
          numericValue = 6;
        }
      }

      input.value = numericValue.toString();
      this.requestFOC = numericValue;
    } else {
      input.value = '';
      this.requestFOC = null;
    }
  }

  onEmptyBoxesInput(event: any) {
    const input = event.target as HTMLInputElement;
    const inputValue = input?.value;

    // Remove non-numeric characters
    const sanitizedValue = inputValue.replace(/[^0-9]/g, '');
    
    if (sanitizedValue !== '') {
      let numericValue = parseInt(sanitizedValue);

      if (this.isRocheProgram) {
        // For Roche program: min = 0, max = 6
        if (numericValue < 0) {
          numericValue = 0;
        } else if (numericValue > 6) {
          numericValue = 6;
        }
      } else {
        // For non-Roche programs: min = 1
        if (numericValue < 1) {
          numericValue = 1;
        }
      }

      input.value = numericValue.toString();
      this.requestEmptyBoxes = numericValue;
    } else {
      input.value = '';
      this.requestEmptyBoxes = this.isRocheProgram ? 0 : null;
    }
  }
}
